export const css = {
    root: '_3T5T4pY-',
    title: '_2GYehrWo',
    closeable: '_12SgN3qe',
    titleButton: '_34TkTxCR',
    content: '_3NVo_7Z4',
    contentTransition: '_2_4swTPT',
    open: '_2J1OiKQ4',
    arrow: '_1cQeMTYK',
    ' _key': 'base-widgets/title-pane'
};
export default css;
